import React from 'react'

// components
import {
  CCol,
  CRow,
  CFormLabel
} from '@coreui/react-pro'
import FormTextInput from '../general-input-form/FormTextInput'
import FormTextAreaInput from '../general-input-form/FormTextAreaInput'
import FormDatePicker from '../general-input-form/FormDatePicker'
import FormPhoneNumber from '../general-input-form/FormPhoneNumber'
import FormSwitchInput from '../general-input-form/FormSwitchInput'
import FormSelectInput from '../general-input-form/FormSelectInput'
import FormEmployeeEducation from '../general-input-form/FormEmployeeEducation'
import FormEmployeeAccount from '../general-input-form/FormEmployeeAccount'
import FormEmployeeSalaryDetail from '../general-input-form/FormEmployeeSalaryDetail'
import FormFileUpload from '../general-input-form/FormFileUpload'
import FormImageThumbnail from '../general-input-form/FormImageThumbnail'
import FormFileThumbnail from '../general-input-form/FormFileThumbnail'
import { getFileType } from 'src/helpers/get-file-type'
import AppCard from '../../AppCard'
import AppCardHeader from 'src/components/card/AppCardHeader'

const AppForm = ({
  values,
  handleChange,
  errors,
  onDateChange,
  countryOptions,
  country,
  setCountry,
  handleSelectCountry,
  genderOptions,
  gender,
  handleSelectGender,
  statusContractOptions,
  statusContract,
  handleSelectStatusContract,
  degreeOptions,
  projectOptions,
  handleAddEmployeeEducations,
  handleChangeEducation,
  handleSelectEducation,
  handleRemoveEmployeeEducation,
  handleSelectProject,
  projects,
  handleAddEmployeeAccounts,
  handleChangeAccount,
  handleRemoveEmployeeAccount,
  handleAddEmployeeSalaryDetails,
  handleChangeSalaryDetails,
  handleRemoveEmployeeSalaryDetails,
  handleRemoveImage,
  handleFileInput,
  handleFileOnDrop,
  setOpenFilePreview,
  editPage,
  salaryTypeOptions,
  handleCardHeaderButton,
  handleConfirmDelete,
  lastAccordionSalaryDetailRef,
  activeAccordionKey,
  setActiveAccordionKey
}) => {
    let fileType = ''
    let npwpUrl = ''
    if (values.npwp_image?.length > 0) {
      if (values.npwp_image[0]?.name) {
        fileType = getFileType(values.npwp_image[0]?.name)
        npwpUrl = values.npwp_image[0]
      } else if (values.npwp_image[0]?.file_original_name) {
        fileType = getFileType(values.npwp_image[0]?.file_original_name)
        npwpUrl = values.npwp_image[0]?.file_url
      } else {
        fileType = getFileType(values.npwp_image[0])
      }
    }
  return (
    <>
      <CRow className="mb-4">
        <FormTextInput 
          id='employee_first_name'
          name='employee_first_name'
          colSize='6'
          inputLabel='First Name'
          className='mb-3'
          placeholder='Enter first name...'
          value={values.employee_first_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.employee_first_name}
          invalid={errors.employee_first_name}
        />
        <FormTextInput 
          id='employee_last_name'
          name='employee_last_name'
          colSize='6'
          inputLabel='Last Name'
          className='mb-3'
          placeholder='Enter last name...'
          value={values.employee_last_name}
          handleTextInput={handleChange}
          feedbackInvalid={errors.employee_last_name}
          invalid={errors.employee_last_name}
        />
        <FormTextInput 
          id='employee_no'
          name='employee_no'
          colSize='6'
          inputLabel='Employee No'
          className='mb-3'
          placeholder='Enter employee no...'
          value={values.employee_no}
          handleTextInput={handleChange}
          feedbackInvalid={errors.employee_no}
          invalid={errors.employee_no}
        />
        <FormTextInput 
          id='employee_email_address'
          name='employee_email_address'
          colSize='6'
          inputLabel='Email Address'
          className='mb-3'
          placeholder='Enter email address...'
          value={values.employee_email_address}
          handleTextInput={handleChange}
          feedbackInvalid={errors.employee_email_address}
          invalid={errors.employee_email_address}
        />
        <FormTextInput 
          id='employee_job_title'
          name='employee_job_title'
          colSize='6'
          inputLabel='Job Title/Position'
          className='mb-3'
          placeholder='Enter job title/position...'
          value={values.employee_job_title}
          handleTextInput={handleChange}
          feedbackInvalid={errors.employee_job_title}
          invalid={errors.employee_job_title}
        />
        <FormTextInput 
          id='employee_place_of_birth'
          name='employee_place_of_birth'
          colSize='6'
          inputLabel='Place of Birth'
          className='mb-3'
          placeholder='Enter place of birth...'
          value={values.employee_place_of_birth}
          handleTextInput={handleChange}
          feedbackInvalid={errors.employee_place_of_birth}
          invalid={errors.employee_place_of_birth}
        />
        <FormDatePicker 
          id='employee_date_of_birth'
          name='employee_date_of_birth'
          colSize='6'
          inputLabel='Date of Birth'
          className='mb-3'
          handleOnDateChange={onDateChange}
          value={values.employee_date_of_birth}
          feedbackInvalid={errors.employee_date_of_birth}
          invalid={errors.employee_date_of_birth}
        />
        <FormSelectInput 
          id='employee_gender'
          name='employee_gender'
          colSize='6'
          inputLabel='Gender'
          className='mb-3'
          selectOptions={genderOptions}
          value={gender}
          handleSelectInput={handleSelectGender}
          feedbackInvalid={errors.employee_gender}
          invalid={errors.employee_gender}
          disabled={false}
          placeholder='Please select gender...'
        />
        <FormSelectInput 
          id='employee_status'
          name='employee_status'
          colSize='6'
          inputLabel='Status Contract'
          className='mb-3'
          selectOptions={statusContractOptions}
          value={statusContract}
          handleSelectInput={handleSelectStatusContract}
          feedbackInvalid={errors.employee_status}
          invalid={errors.employee_status}
          disabled={false}
          placeholder='Please select status contract...'
        />
        {
          values?.is_contract_base && (
            <>
              <FormDatePicker 
                id='employee_contract_start_date'
                name='employee_contract_start_date'
                colSize='6'
                inputLabel='Contract Start Date'
                className='mb-3'
                handleOnDateChange={onDateChange}
                value={values.employee_contract_start_date}
                feedbackInvalid={errors.employee_contract_start_date}
                invalid={errors.employee_contract_start_date}
              />
              <FormDatePicker 
                id='employee_contract_end_date'
                name='employee_contract_end_date'
                colSize='6'
                inputLabel='Contract End Date'
                className='mb-3'
                handleOnDateChange={onDateChange}
                value={values.employee_contract_end_date}
                feedbackInvalid={errors.employee_contract_end_date}
                invalid={errors.employee_contract_end_date}
              />
            </>
          )
        }
        <FormPhoneNumber
          colSize='6'
          inputLabel='Contact Number'
          placeholder='Enter contact number...'
          className='mb-3'
          countryOptions={countryOptions}
          country={country}
          setCountry={setCountry}
          value={values}
          handlePhoneNumber={handleChange}
          handlePhoneCountry={handleSelectCountry}
          errors={errors}
        />
        <FormTextInput 
          id='employee_id_card_number'
          name='employee_id_card_number'
          colSize='6'
          inputLabel='NIK'
          className='mb-3'
          placeholder='Enter NIK number...'
          value={values.employee_id_card_number}
          handleTextInput={handleChange}
          feedbackInvalid={errors.employee_id_card_number}
          invalid={errors.employee_id_card_number}
        />
        <FormTextInput 
          id='employee_bpjs_kis_no'
          name='employee_bpjs_kis_no'
          colSize='6'
          inputLabel='BPJS KIS'
          className='mb-3'
          placeholder='Enter BPJS KIS number...'
          value={values.employee_bpjs_kis_no}
          handleTextInput={handleChange}
          feedbackInvalid={errors.employee_bpjs_kis_no}
          invalid={errors.employee_bpjs_kis_no}
        />
        <FormTextAreaInput
          id='employee_address'
          name='employee_address'
          colSize='6'
          inputLabel='Address'
          className='mb-3'
          placeholder='Enter address...'
          rows='5'
          value={values.employee_address}
          handleTextAreaInput={handleChange}
          feedbackInvalid={errors.employee_address}
          invalid={errors.employee_address}
        />
        <FormSwitchInput 
          id='is_active'
          name='is_active'
          label={values.is_active ? 'active' : 'inactive'}
          colSize='6'
          inputLabel='Status'
          className='mb-3'
          handleSwitch={handleChange}
          value={values.is_active}
          invalid={errors?.is_active}
        />
        <FormSelectInput 
          id='project_assign_id'
          name='project_assign_id'
          colSize='6'
          inputLabel='Project Assigned'
          className='mb-3'
          selectOptions={projectOptions}
          value={projects}
          handleSelectInput={handleSelectProject}
          feedbackInvalid={errors.project_assign_id}
          invalid={errors.project_assign_id}
          disabled={false}
          multiple={true}
          placeholder='Please select project...'
        />
        <FormDatePicker 
          id='employee_register_date'
          name='employee_register_date'
          colSize='6'
          inputLabel='Register Date'
          className='mb-3'
          handleOnDateChange={onDateChange}
          value={values.employee_register_date}
          feedbackInvalid={errors.employee_register_date}
          invalid={errors.employee_register_date}
        />
        <FormTextAreaInput
          id='employee_notes'
          name='employee_notes'
          colSize='6'
          inputLabel='Notes'
          className='mb-3'
          placeholder='Enter notes...'
          rows='5'
          value={values.employee_notes}
          handleTextAreaInput={handleChange}
          feedbackInvalid={errors.employee_notes}
          invalid={errors.employee_notes}
        />
        {values.npwp_image.length > 0 ? fileType && fileType == 'image' ? (
          <FormImageThumbnail
            editPage={editPage}
            inputLabel='Document NPWP'
            name='npwp_image'
            colSize='6'
            productImages={values.npwp_image}
            handleChangeImage={handleFileInput}
            handleRemoveImage={handleRemoveImage}
            setOpenFilePreview={() => setOpenFilePreview(npwpUrl)}
          />
        ) : (
          <CCol lg={6}>
            <CFormLabel>
              Document NPWP
            </CFormLabel>
            <FormFileThumbnail 
              name='npwp_image'
              colSize='6'
              files={values.npwp_image}
              className='justify-content-start align-items-center'
              handleViewFile={setOpenFilePreview}
              handleConfirmDelete={handleRemoveImage}
            />
          </CCol>
        ) : (
          <FormFileUpload
            name='npwp_image'
            colSize='6'
            inputLabel='Document NPWP'
            handleFileInput={handleFileInput}
            handleFileOnDrop={handleFileOnDrop}
            multiple={false}
            invalid={errors.npwp_image}
            feedbackInvalid={errors.npwp_image}
            maxFiles={1}
          />
        )}
        <CCol>
          <AppCard 
            className='my-4'
            headerTitle={
              <AppCardHeader
                headerTitle={<h4>Attachments</h4>}
                headerButton="Upload new"
                handleCardHeaderButton={handleCardHeaderButton}
              />
            }
            bodyContent={
              <>
                {
                  values?.attachments?.length > 0 ? (
                    <FormFileThumbnail 
                      name='employee_attachments'
                      colSize='3'
                      files={values?.attachments}
                      className='justify-content-start align-items-center'
                      handleConfirmDelete={handleConfirmDelete}
                      handleViewFile={setOpenFilePreview}
                    />
                  )
                  : (
                    <>Not Found</>
                  )
                }
              </>
            }
          />
        </CCol>
        <FormEmployeeEducation 
          colSize='12'
          inputLabel='Employee Education'
          className={'mb-3'}
          errors={errors}
          degreeOptions={degreeOptions}
          countryOptions={countryOptions}
          employeeEducations={values.employee_educations}
          handleAddEmployeeEducations={handleAddEmployeeEducations}
          handleChangeEducation={handleChangeEducation}
          handleSelectEducation={handleSelectEducation}
          handleRemoveEmployeeEducation={handleRemoveEmployeeEducation}
          disabled={false}
        />
        <FormEmployeeAccount 
          colSize='12'
          inputLabel='Employee Account'
          className={'mb-3'}
          errors={errors}
          employeeAccounts={values.employee_accounts}
          handleAddEmployeeAccounts={handleAddEmployeeAccounts}
          handleChangeAccount={handleChangeAccount}
          handleRemoveEmployeeAccount={handleRemoveEmployeeAccount}
          disabled={false}
        />
        <FormEmployeeSalaryDetail 
          colSize='12'
          inputLabel='Employee Salary Details'
          className={'mb-3'}
          errors={errors}
          salaryDetails={values.employee_salary_details}
          handleAddEmployeeSalaryDetails={handleAddEmployeeSalaryDetails}
          handleChangeSalaryDetails={handleChangeSalaryDetails}
          handleRemoveEmployeeSalaryDetails={handleRemoveEmployeeSalaryDetails}
          disabled={false}
          salaryTypeOptions={salaryTypeOptions}
          lastAccordionRef={lastAccordionSalaryDetailRef}
          activeAccordionKey={activeAccordionKey}
          setActiveAccordionKey={setActiveAccordionKey}
        />
      </CRow>
    </>
  )
}

export default AppForm